import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './main-sidebar';
import SidebarItem from './sidebarItems';
import { ArchiveIcon, ChartArea, Delete, DeleteIcon, Home,  MergeIcon, Trash2Icon, Users } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { FaCcMastercard } from 'react-icons/fa';

const SidebarWrapper = ({ children, hideRoutes = [] }) => {
  const location = useLocation();
  const { user } = useAuth(); // Get the user object from useAuth

  // Define sidebar items conditionally based on the user's role
  const sidebarItems = [
    // {
    //   icon: <Home className="w-4 h-4" />,
    //   text: 'Dashboard',
    //   href: '/',
    //   alert: false,
    // },
    {
      icon: <ArchiveIcon className="w-4 h-4" />,
      text: 'Merge',
      href: '/merge',
      alert: false,
    },
    {
      icon: <MergeIcon className="w-4 h-4" />,
      text: 'Lookup',
      href: '/invoice-lookup',
      alert: false,
    },
    {
      icon: <FaCcMastercard className="w-4 h-4" />,
      text: 'List',
      href: '/master-invoice',
      alert: false,
    },
    {
      icon: <Trash2Icon className="w-4 h-4" />,
      text: 'deleted',
      href: '/deleted-invoice',
      alert: false,
    },
    // {
    //   icon: <ChartArea className="w-4 h-4" />,
    //   text: 'Reports',
    //   href: '/report',
    //   alert: false,
    // },
  ];

  // Add "Users" item only if the user's role is "admin"
  if (user?.role === 'admin') {
    sidebarItems.push({
      icon: <Users className="w-4 h-4" />,
      text: 'Users',
      href: '/users',
      alert: false,
    });
  }

  // Check if the current path matches any of the routes where the sidebar should be hidden
  if (hideRoutes.includes(location.pathname)) {
    return <>{children}</>; // Render only children if the sidebar is hidden
  }

  return (
    <div className="flex w-full h-screen">
      <div className="flex-shrink-0">
        <Sidebar>
          {sidebarItems.map((item, index) => (
            <SidebarItem
              key={index}
              icon={item.icon}
              text={item.text}
              href={item.href}
              alert={item.alert}
            />
          ))}
        </Sidebar>
      </div>
      <div className="flex-grow overflow-y-auto">{children}</div>
    </div>
  );
};

export default SidebarWrapper;
